<ion-list-header class="card" [class.collapsed]="Collapsed">
	<ion-item class="full">
		<ion-grid class="full">

			<ion-row class="ion-justify-content-center ion-align-items-center">
				<ion-col *ngIf="!Collapsed">
					<ion-img button [routerLink]="[HomePath]" class="logo" [src]="ProjectLogo"></ion-img>
				</ion-col>
				<ion-col [size]="Collapsed ? 12 : 'auto'">
					<ion-buttons class="menu-actions" [class.ion-justify-content-end]="!Collapsed">
						<ion-button [routerLink]="[NotificationPath]" routerLinkActive="selected" [title]="Collapsed ? 'Notificações' : ''">
                            <ion-badge id="notifications-badge" color="danger" *ngIf="CounterNotifications > 0 && CounterNotifications <= 9">{{CounterNotifications}}</ion-badge>
							<ion-badge id="notifications-badge" color="danger" *ngIf="CounterNotifications > 9">+9</ion-badge>
							<ion-icon name="notifications-outline" slot="icon-only"></ion-icon>
						</ion-button>
					</ion-buttons>
				</ion-col>
			</ion-row>

		</ion-grid>

	</ion-item>
</ion-list-header>
